import { apiClient } from './apiClient';
import type { ApiResponse } from '@/types/api.types';

/** reply = conversations, confirm = appointment confirmations, marketing = campaigns. */
export type FacilitySmsNumberKind = 'reply' | 'confirm' | 'marketing';

export const FACILITY_SMS_NUMBER_KINDS: FacilitySmsNumberKind[] = ['reply', 'confirm', 'marketing'];

/** 10-digit numbers, or null where the facility uses the practice's own. */
export type FacilitySmsNumberSet = Record<FacilitySmsNumberKind, string | null>;

export interface FacilitySmsNumbersEntry {
  facilityId: number;
  name: string;
  active: boolean;
  numbers: FacilitySmsNumberSet;
}

export interface FacilitySmsNumbersOverview {
  practiceNumbers: FacilitySmsNumberSet;
  facilities: FacilitySmsNumbersEntry[];
}

export function getFacilitySmsNumbers(): Promise<FacilitySmsNumbersOverview> {
  return apiClient
    .get<ApiResponse<FacilitySmsNumbersOverview>>('/facilities/sms-numbers')
    .then((r) => r.data.data);
}

/** Numbers the practice owns that are not assigned anywhere yet. */
export function getAvailableFacilitySmsNumbers(): Promise<string[]> {
  return apiClient
    .get<ApiResponse<{ numbers: string[] }>>('/facilities/sms-numbers/available')
    .then((r) => r.data.data.numbers ?? []);
}

export function assignFacilitySmsNumber(
  facilityId: number,
  kind: FacilitySmsNumberKind,
  phoneNumber: string,
): Promise<void> {
  return apiClient
    .put(`/facilities/${facilityId}/sms-numbers/${kind}`, { phoneNumber })
    .then(() => undefined);
}

export function removeFacilitySmsNumber(facilityId: number, kind: FacilitySmsNumberKind): Promise<void> {
  return apiClient.delete(`/facilities/${facilityId}/sms-numbers/${kind}`).then(() => undefined);
}
